module.exports = __webpack_public_path__ + "img/wllogo.4ac42f47.png";